import appConfig from 'configs/app.config'
import { AUTH_STORAGE_KEYS } from 'constants/auth.constant'
import store, { persistor } from 'store'
import { onSignOutSuccess, setAuthSession } from 'store/auth/sessionSlice'
import { initialState, setUser } from 'store/auth/userSlice'

export const getStoredAuth = () => ({
    accessToken: localStorage.getItem(AUTH_STORAGE_KEYS.accessToken) || '',
    refreshToken: localStorage.getItem(AUTH_STORAGE_KEYS.refreshToken) || '',
    sessionId: localStorage.getItem(AUTH_STORAGE_KEYS.sessionId) || '',
})

export const setStoredAuth = ({ accessToken = '', refreshToken = '', sessionId = '' }) => {
    if (accessToken) {
        localStorage.setItem(AUTH_STORAGE_KEYS.accessToken, accessToken)
    } else {
        localStorage.removeItem(AUTH_STORAGE_KEYS.accessToken)
    }

    if (refreshToken) {
        localStorage.setItem(AUTH_STORAGE_KEYS.refreshToken, refreshToken)
    } else {
        localStorage.removeItem(AUTH_STORAGE_KEYS.refreshToken)
    }

    if (sessionId) {
        localStorage.setItem(AUTH_STORAGE_KEYS.sessionId, sessionId)
    } else {
        localStorage.removeItem(AUTH_STORAGE_KEYS.sessionId)
    }

    localStorage.removeItem(AUTH_STORAGE_KEYS.legacyToken)

    store.dispatch(setAuthSession({ accessToken, refreshToken, sessionId }))
}

export const clearAuthState = async () => {
    localStorage.removeItem(AUTH_STORAGE_KEYS.accessToken)
    localStorage.removeItem(AUTH_STORAGE_KEYS.refreshToken)
    localStorage.removeItem(AUTH_STORAGE_KEYS.sessionId)
    localStorage.removeItem(AUTH_STORAGE_KEYS.legacyToken)
    localStorage.removeItem(AUTH_STORAGE_KEYS.userInfo)
    localStorage.removeItem(AUTH_STORAGE_KEYS.userFullInfo)

    store.dispatch(onSignOutSuccess())
    store.dispatch(setUser(initialState))

    await persistor.flush()
    await persistor.purge()
}

let forceLogoutInProgress = false

const isOnSignInRoute = () => {
    const signInPath = appConfig.unAuthenticatedEntryPath
    const currentPath = window.location.pathname
    return currentPath === signInPath
}

export const forceLogout = async (reason = 'SESSION_INVALID') => {
    if (forceLogoutInProgress) {
        return
    }

    forceLogoutInProgress = true

    try {
        await clearAuthState()
        if (!isOnSignInRoute()) {
            window.location.assign(`${appConfig.unAuthenticatedEntryPath}?reason=${encodeURIComponent(reason)}`)
        }
    } finally {
        forceLogoutInProgress = false
    }
}
